import { useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import VendorOrganizationForm from "./VendorOrganizationForm";
import { useCreateProvider } from "../../../custom-hooks/queries";

const CreateVendorAccountPage = () => {
  const navigate = useNavigate();
  const provisionalProviderId = useRef(uuidv4());
  const { mutate: createProvider } = useCreateProvider();

  const handleCreateSubmit = useCallback(
    (vendorData, { setIsLoading, setIsSuccess, setMessage, setAlertOpen }) => {
      createProvider(vendorData, {
        onSuccess: () => {
          setIsLoading(false);
          setIsSuccess(true);
          setMessage("Vendor created successfully!");
          setAlertOpen(true);
          setTimeout(() => {
            navigate("/Backend/Users/Vendors");
          }, 2000);
        },
        onError: (error) => {
          setIsLoading(false);
          setIsSuccess(false);
          setMessage(
            error.response?.data?.message ||
              error.message ||
              "Error creating vendor",
          );
          setAlertOpen(true);
        },
      });
    },
    [createProvider, navigate],
  );

  return (
    <VendorOrganizationForm
      mode="create"
      showTeamTab={false}
      provisionalProviderId={provisionalProviderId.current}
      onCreateSubmit={handleCreateSubmit}
    />
  );
};

export default CreateVendorAccountPage;
